import { motion } from 'motion/react';

export const ButtonLoader = () => {
    return (
        <div className="flex items-center gap-1 h-full mx-2">
            {[0, 1, 2].map((i) => (
                <motion.div
                    key={i}
                    className="w-1.5 h-1.5 bg-current rounded-full"
                    animate={{ y: [0, -3, 0] }}
                    transition={{
                        duration: 0.5,
                        repeat: Infinity,
                        delay: i * 0.1,
                        ease: "easeInOut"
                    }}
                />
            ))}
        </div>
    );
};
